// check4dnr/src/components/Login.js
import React, { useState, useContext } from 'react';
import { Container, TextField, Button, Typography, Box } from '@mui/material';
import { signIn } from './cognito';
import { UserContext } from '../context/UserContext';
import { useNavigate, useLocation } from 'react-router-dom';

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loginResultMessage, setLoginResultMessage] = useState('');
  const { setUserGuid, setFirstName, setLastName, setEmail, setTokens } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const redirectPath = location.state?.redirectAfterLogin || '/profile';
  const message = location.state?.message || '';

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    setLoginResultMessage('');
    try {
      const response = await signIn(formData.email, formData.password);
      if (response.success) {
        setLoginResultMessage('Login successful!');
        // Store tokens in UserContext and localStorage
        setTokens({
          accessToken: response.accessToken,
          idToken: response.idToken,
          refreshToken: response.refreshToken,
        });
        setUserGuid(response.user.cognitoGuid);
        setEmail(response.user.email);

        // Optionally, fetch additional user info from DynamoDB
        // You might need to create an API endpoint to retrieve user details using cognitoGuid
        // For simplicity, assuming firstName and lastName are stored in localStorage or fetched here

        // Redirect to profile page
        navigate(redirectPath);
      }
    } catch (error) {
      console.error('Login error:', error);
      setLoginResultMessage(error.message || 'An error occurred during login.');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        Log In
      </Typography>
      {message && (
        <Box 
          sx={{ 
            mb: 3, 
            p: 2, 
            bgcolor: 'rgba(25, 118, 210, 0.1)', 
            borderRadius: 1,
            color: 'primary.main'
          }}
        >
          <Typography variant="body1">
            {message}
          </Typography>
        </Box>
      )}
      <TextField
        label="Email"
        name="email"
        fullWidth
        margin="normal"
        value={formData.email}
        onChange={handleInputChange}
      />
      <TextField
        label="Password"
        name="password"
        type="password"
        fullWidth
        margin="normal"
        value={formData.password}
        onChange={handleInputChange}
      />
      <Button variant="contained" color="primary" onClick={handleLogin} fullWidth sx={{ mt: 2 }}>
        Log In
      </Button>
      <Typography variant="body2" sx={{ mt: 2 }}>
        Don't have an account? <a href="/signup">Sign Up</a>
      </Typography>
      <Typography variant="body2" sx={{ mt: 2 }}>
        Forgot your password? <a href="/reset-password">Reset it here</a>
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        {loginResultMessage}
      </Typography>
    </Container>
  );
}

export default Login;